import { css } from "@emotion/css";
import styled from "@emotion/styled";

const GameSoon = () => (
  <div>
    <Label
      className={css`
        font-size: 14px;
      `}
    >
      Game starts
    </Label>
    <Label
      className={css`
        font-size: 86px;
      `}
    >
      Soon
    </Label>
  </div>
);

const Label = styled.div`
  font-weight: 700;
  text-align: center;
  color: #ffffff;
`;

export default GameSoon;
